// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2ujUA","content":"RecentSearches_content__3bmHW"};